import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { navItems } from '../data/navigation';
export function Header() {
  const [open, setOpen] = useState(false);
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [pathname]);
  const mainItems = navItems.filter(item => item.path !== '/contact');
  return <header className="sticky top-0 z-40 border-b border-line bg-paper/95 backdrop-blur" data-id="element-38" data-mp="2wjxlnkgscayi">
      <div className="mx-auto flex h-20 max-w-site items-center justify-between px-6 lg:px-10" data-id="element-39" data-mp="31d04oynxs20g">
        <Logo data-id="element-40" data-mp="36a0bxcwivat5" />

        <nav aria-label="Navigation principale" className="hidden lg:block" data-id="element-41" data-mp="369qnhtr4lbpk">
          <ul className="flex items-center gap-9" data-id="element-42" data-mp="3baxuhqlg26v6">
            {mainItems.map(item => <li key={item.path} data-id="element-43" data-mp="3fayio2ychwff">
                <NavLink to={item.path} className={({
              isActive
            }) => `relative whitespace-nowrap py-2 text-[15px] transition-colors duration-150 ${isActive ? 'text-ink' : 'text-muted hover:text-ink'}`} data-id="element-44" data-mp="3fc9os9f9jg9p">
                  {({
                isActive
              }) => <>
                      {item.label}
                      {isActive && <span className="absolute inset-x-0 -bottom-[1px] h-px bg-ink" data-id="element-45" data-mp="3fbvldi01xepu" />}
                    </>}
                </NavLink>
              </li>)}
          </ul>
        </nav>

        <div className="flex items-center gap-4" data-id="element-46" data-mp="35kr9ir5oa9z8">
          <NavLink to="/contact" className="hidden whitespace-nowrap bg-ink px-5 py-2.5 text-[15px] text-paper transition-colors duration-150 hover:bg-ink-soft focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink sm:inline-block" data-id="element-47" data-mp="35j6bgrk5g8wm">
            Nous contacter
          </NavLink>
          <button type="button" onClick={() => setOpen(v => !v)} className="flex h-10 w-10 items-center justify-center text-ink lg:hidden" aria-expanded={open} aria-controls="menu-mobile" aria-label={open ? 'Fermer le menu' : 'Ouvrir le menu'} data-id="element-48" data-mp="1rew406xb27lv">
            {open ? <XIcon className="h-5 w-5" data-id="element-49" data-mp="1mki7g16wpufm" /> : <MenuIcon className="h-5 w-5" data-id="element-50" data-mp="18mk4rt1y7mfy" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-51" data-mp="1cof790vm85vb">
        {open && <motion.nav id="menu-mobile" aria-label="Navigation mobile" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="border-t border-line bg-paper lg:hidden" data-id="element-52" data-mp="1cq8eoie1yu4d">
            <ul className="mx-auto max-w-site px-6 py-4" data-id="element-53" data-mp="2y29ts377dyxt">
              {navItems.map(item => <li key={item.path} className="border-b border-line last:border-0" data-id="element-54" data-mp="mdv8iux182gh">
                  <NavLink to={item.path} className={({
              isActive
            }) => `block py-4 font-serif text-xl ${isActive ? 'text-ink' : 'text-ink-soft'}`} data-id="element-55" data-mp="hftljywhjizq">
                    {item.label}
                  </NavLink>
                </li>)}
            </ul>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}